import { countries } from 'constants/countries';
import lookup from 'country-code-lookup';
import i18next from 'i18next';
import { ICountry } from 'services/enums/types';

export const getCountries = (countries?: ICountry[]) => {
  if (!countries?.length) return [];

  const locale = typeof navigator !== 'undefined' ? navigator.language : '';
  const regionCode = locale.split('-')[1]?.toUpperCase();
  const region = lookup.byIso(regionCode)?.iso2 || null;

  const sorted = [...countries].sort((a, b) => {
    if (!region) return 0;
    if (a.codeAlfa2 === region) return -1;
    if (b.codeAlfa2 === region) return 1;
    return 0;
  });

  return sorted.map(country => ({
    label: i18next.t(`countries.${country.codeAlfa2}`),
    value: country.codeAlfa2,
  }));
};
export const getCountriesPhoneNumberPrefixOptionValues = () => {
  const locale = typeof navigator !== 'undefined' ? navigator.language : '';
  const regionCode = locale.split('-')[1]?.toUpperCase();
  const region = lookup.byIso(regionCode)?.iso2 || null;

  const sortedCountries = [...countries].sort((a, b) => {
    if (a.iso?.['alpha-2'] === region) return -1;
    if (b.iso?.['alpha-2'] === region) return 1;
    return 0;
  });

  return sortedCountries
    .filter(country => !!country.phone?.length)
    .map(country => ({
      label: `${country.emoji} ${country.name}`,
      options: country.phone?.map(phone => ({
        label: phone,
        value: phone,
      })),
    }));
};
